import React from 'react';

function Favourite() {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7711 9.91023C19.6998 7.75056 19.6283 4.43956 17.5548 2.36056C15.4804 0.282482 12.1529 0.218315 9.99962 2.15156C7.83995 0.215565 4.51887 0.285232 2.44262 2.36056C0.370037 4.43406 0.29762 7.75056 2.22629 9.91023L9.99779 17.6946L17.7711 9.91023ZM3.5633 8.65427C2.30472 7.2096 2.37347 5.02335 3.7393 3.65752C5.06939 2.32652 7.17955 2.22752 8.6233 3.3871L8.69847 3.45035L6.10889 6.04177L7.40597 7.33794L11.2578 3.48518C12.6988 2.22385 14.8933 2.28985 16.2564 3.65568C17.6241 5.0261 17.6928 7.2096 16.4333 8.65519L9.9983 15.0994L3.5633 8.65427Z"
        fill="black"
      />
    </svg>
  );
}

export default Favourite;
